import React from 'react';
import styles from './index.module.less';
import {Button, ButtonGroup, Classes, Icon, Intent, NonIdealState, Tab, Tabs, Tree} from "@blueprintjs/core";
import useCodeEditorData from "./useCodeEditorData";
import EditorPanel from "./editor-panel";
import TabTitle from "./table-title";
import EditorTerminal from "./editor-terminal";
import useCodeEditorLayout from "./useCodeEditorLayout";

const CodeEditor = ({ defaultDirectory = [], output = {}, onRunCode, directoryEditable}) => {

  const { directory, openedFiles, handleNodeClick, openedFileId, setOpenedFileId, handleCloseFile, handleChangeCode, handleNodeContextMenu, filesTreeRef } = useCodeEditorData(defaultDirectory, directoryEditable);
  const {editorMainHeight, projectAreaWidth, terminalAreaHeight, editorAppHeight, codeAreaHeight, editorApp, editorMainRef, horizontalBarRef, toolbarRef, bindHorizontalDrag, bindVerticalDrag} = useCodeEditorLayout();

  const renderTabs = () => {
    if (openedFiles.size > 0) {
      return (
        <Tabs renderActiveTabPanelOnly selectedTabId={openedFileId} onChange={setOpenedFileId}>
          {[...openedFiles.values()].map((file) => (
            <Tab panelClassName={styles['editor-panel']} key={file.id} id={file.id} title={<TabTitle onClose={() => handleCloseFile(file.id)} label={file.label} />} panel={<EditorPanel onChangeCode={(code) => handleChangeCode(file.id, code)} defaultCode={file.code} height={codeAreaHeight} />} />
          ))}
        </Tabs>
      )
    }
    return (
      <NonIdealState
        icon='inbox-geo'
        description={<span style={{ color: '#a7b6c2', userSelect: 'none' }}>请点击左侧目录打开文件</span>}
      />
    );
  };

  const renderActions = () => {
    return (
      <div className={styles.toolbar} ref={toolbarRef}>
        <ButtonGroup>
          <Button icon='play' onClick={() => onRunCode([...directory])}>运行代码</Button>
          <Button icon='eye-open'>代码可视化</Button>
          <Button icon='reset'>重置代码</Button>
        </ButtonGroup>
      </div>
    )
  };

  return (
    <div className={styles['editor-app']} ref={editorApp} style={{ height: editorAppHeight }}>
      <div className={styles.project} style={{ width: projectAreaWidth, height: editorAppHeight }}>
        <div className={styles.toolbar}>
          <span className={Classes.TEXT_MUTED}>正在完成练习题</span>
          <ButtonGroup className={Classes.MINIMAL}>
            <Button icon='small-cross' intent={Intent.DANGER} />
          </ButtonGroup>
        </div>
        <div className={styles['dir-tree']} ref={filesTreeRef}>
          <Tree contents={directory} onNodeClick={handleNodeClick} onNodeContextMenu={handleNodeContextMenu} />
        </div>
      </div>
      <div className={styles['drag-trigger']} { ...bindVerticalDrag() }>
        <Icon icon='drag-handle-vertical' iconSize={12} />
      </div>
      <div className={styles['editor-panels']}>
        <div className={styles['editor-main']} ref={editorMainRef} style={{ height: editorMainHeight }}>
          {renderTabs()}
        </div>
        <div ref={horizontalBarRef} className={styles['horizontal-drag-trigger']} {...bindHorizontalDrag()}>
          <Icon icon='drag-handle-horizontal' iconSize={12} />
        </div>
        <EditorTerminal height={terminalAreaHeight} stdout={output.stdout} stderr={output.stderr} message={output.message} />
        {renderActions()}
      </div>
    </div>
  );
};

export default CodeEditor;
